// PortfolioMain.js
import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import LetsPortfolio from './components/LetsPortfolio';
import { addPortfolio, removePortfolio } from '../../stores/portfolioSlice';
import Portfolios from './Portfolios';
import { PortfolioServiceApi, Configuration } from "../../services/portfolio";
import { APIControl } from '../../helpers/APIControl';
import COLORS from '../../constants/color';
import Spinner from '../../components/spinner';
import { Toast } from 'primereact/toast';

const PortfolioMain = () => {
    const hasPortfolio = useSelector((state) => state.portfolio.hasPortfolio);
    const portfolioServiceApi = new PortfolioServiceApi(new Configuration({ basePath: process.env.REACT_APP_PORTFOLIO_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_PORTFOLIO_API_BASE_PATH));
    const token = useSelector((state) => state.auth?.token);
    const toast = useRef(null);

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);

    const handleAddPortfolio = () => {
        dispatch(addPortfolio());
    };

    useEffect(() => {
        fetchPortfoliosData();
    }, []);

    const fetchPortfoliosData = async () => {
        setIsLoading(true);
        try {
            const response = await portfolioServiceApi.v1PortfoliosGet(token);
            const portfolios = response.data.portfolios;

            if (portfolios && portfolios.length > 0) {
                dispatch(addPortfolio());
            } else {
                dispatch(removePortfolio());
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || "Portföy verileri alınırken bir hata oluştu.";
            toast.current.show({ severity: 'error', summary: 'Hata', detail: errorMessage, life: 3000 });
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='PortfolioPageContainer'>
            <Toast ref={toast} />

            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>

                    <Spinner />
                </div>
            ) : hasPortfolio ? (
                <Portfolios fetchPortfoliosData={fetchPortfoliosData} />
            ) : (
                <LetsPortfolio onAddPortfolio={handleAddPortfolio} />
            )}
        </div>
    );
};

export default PortfolioMain;
